/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Judge0Request
 */
export interface Judge0Request {
    /**
     * 
     * @type {string}
     * @memberof Judge0Request
     */
    source_code: string;
    /**
     * 
     * @type {string}
     * @memberof Judge0Request
     */
    stdin: string | null;
}

/**
 * Check if a given object implements the Judge0Request interface.
 */
export function instanceOfJudge0Request(value: object): value is Judge0Request {
    if (!('source_code' in value) || value['source_code'] === undefined) return false;
    if (!('stdin' in value) || value['stdin'] === undefined) return false;
    return true;
}

export function Judge0RequestFromJSON(json: any): Judge0Request {
    return Judge0RequestFromJSONTyped(json, false);
}

export function Judge0RequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): Judge0Request {
    if (json == null) {
        return json;
    }
    return {
        
        'source_code': json['source_code'],
        'stdin': json['stdin'],
    };
}

export function Judge0RequestToJSON(json: any): Judge0Request {
    return Judge0RequestToJSONTyped(json, false);
}

export function Judge0RequestToJSONTyped(value?: Judge0Request | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'source_code': value['source_code'],
        'stdin': value['stdin'],
    };
}

